import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { TaxonomyPicker } from "@/pages/admin/merchant/TaxonomyPicker";

const sel = "h-9 w-full rounded-md border bg-white px-2 text-sm";

export function ProductMerchantPanel({ value, onChange }) {
  const m = value || {};
  const set = (k, v) => onChange({ ...m, [k]: v });
  return (
    <div className="rounded-xl border p-3 space-y-3" data-testid="product-merchant-panel">
      <div className="flex items-center justify-between">
        <div className="font-semibold text-sm">Google Merchant Center</div>
        <label className="flex items-center gap-2 text-sm"><Switch checked={!!m.exclude} onCheckedChange={(v) => set("exclude", v)} data-testid="gmc-exclude" /> Exclude from feed</label>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-xs">GTIN (barcode override)</Label><Input value={m.gtin || ""} onChange={(e) => set("gtin", e.target.value)} placeholder="Uses product barcode" className="h-9" data-testid="gmc-gtin" /></div>
        <div><Label className="text-xs">MPN (manufacturer part no.)</Label><Input value={m.mpn || ""} onChange={(e) => set("mpn", e.target.value)} className="h-9" data-testid="gmc-mpn" /></div>
        <div><Label className="text-xs">Condition</Label>
          <select value={m.condition || ""} onChange={(e) => set("condition", e.target.value)} className={sel} data-testid="gmc-condition">
            <option value="">Default (new)</option><option value="new">New</option><option value="refurbished">Refurbished</option><option value="used">Used</option>
          </select></div>
        <div><Label className="text-xs">Google shipping label</Label>
          <select value={m.shipping_label || ""} onChange={(e) => set("shipping_label", e.target.value)} className={sel} data-testid="gmc-shipping-label">
            <option value="">Automatic (from shipping class)</option><option value="standard">standard</option><option value="small_item">small_item</option>
            <option value="freight">freight</option><option value="custom">custom</option><option value="free_shipping">free_shipping</option>
          </select></div>
        <div className="col-span-2"><Label className="text-xs">Feed title override (optional)</Label><Input value={m.title || ""} maxLength={150} onChange={(e) => set("title", e.target.value)} className="h-9" data-testid="gmc-title" /></div>
        <div className="col-span-2"><Label className="text-xs">Google product category override (blank = category mapping)</Label>
          <TaxonomyPicker value={m.google_category} onChange={(id) => set("google_category", id)} testid="gmc-category" /></div>
      </div>
    </div>
  );
}
